import * as React from 'react';
import { createContext, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type Language = 'es';

interface LanguageContextProps {
  language: Language;
  setLanguage: (lang: Language) => void;
  toggleLanguage: () => void;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

interface LanguageProviderProps {
  children: React.ReactNode;
}

export const LanguageProvider = ({ children }: LanguageProviderProps) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage('es');
    localStorage.setItem('language', 'es');
    document.documentElement.setAttribute('lang', 'es');
  }, [i18n]);

  const value: LanguageContextProps = {
    language: 'es',
    setLanguage: () => {},
    toggleLanguage: () => {},
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextProps => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
